
    /**
    * 获取 名人介绍列表
    * ```

```
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqApiFirstPagePersonList17264 {
  /**
   * 默认为为移动端  传 pc(String)
   */
  type: string | number;
}
    /**
 * Response<PersonListResp> :Response
 */
export class IResApiFirstPagePersonList17264 {
  message: {};
  code: {};
  /**
   * PersonListResp
   */
  data: {
    /**
     * 标题
     */
    title: {};
    /**
     * 人物介绍列表 ,String
     */
    imgs: {}[];
  };
}
    const http: Serve<IReqApiFirstPagePersonList17264, IResApiFirstPagePersonList17264> = (data?) =>  request({
      method: 'GET',
      url: '/api/firstPage/person/list',
      params: data
    }) 
    export default http